






























import { computed, defineComponent, PropType } from 'vue';
import { SearchInstitutionProfileResult } from '../../../shared/models/responses/search/findGeneric.response';
import { InstitutionProfileModel } from '../../../shared/models/institutionProfile.model';
import { useSearchResultProfile } from '../../composables/global_search/useSearchResultProfile';
import Avatar from '../../../shared/components/Avatar.vue';
import KeywordHighlight from 'vue-text-highlight';
import WordHighlight from './WordHighlight.vue';

export default defineComponent({
  name: 'SearchResultItemProfile',
  components: {
    Avatar,
    KeywordHighlight,
  },
  props: {
    result: {
      type: Object as PropType<SearchInstitutionProfileResult>,
      required: true,
    },
    searchString: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { roleLabel, institutionName, searchQueries, openProfile } = useSearchResultProfile(
      () => props.result,
      () => props.searchString
    );

    // Avatar and $getProfileDisplayName expect an InstitutionProfileModel. The
    // search result carries the same fields they rely on (profile picture,
    // short name, name and metadata), so we adapt the type here.
    const profile = computed(() => props.result as unknown as InstitutionProfileModel);

    return {
      profile,
      roleLabel,
      institutionName,
      searchQueries,
      openProfile,
      WordHighlight,
    };
  },
});
